import { IconButton } from '@alto-avios/alto-ui';
import { FC, useContext } from 'react';

import { AuthProps } from '../Header';
import { MobileMenuList } from '../MobileMenuList';
import { Overlay } from '../Overlay';
import { CMSProviderContext } from '../services/content';

export type BurgerMenuProps = AuthProps & {
  isLoggedIn: boolean;
};

export const BurgerMenu: FC<BurgerMenuProps> = ({ isLoggedIn, logoutProps, loginProps }) => {
  const { header } = useContext(CMSProviderContext);
  const { burgerMenuOpenAriaLabel } = header.data;

  const trigger = (
    <IconButton
      aria-label={burgerMenuOpenAriaLabel}
      emphasis="quaternary"
      iconProps={{ iconName: 'bars' }}
      styleVariant="neutral"
      name="menu"
      preventFocusOnPress
    />
  );

  return (
    <Overlay ariaLabel="Mobile Menu" trigger={trigger}>
      <MobileMenuList isLoggedIn={isLoggedIn} loginProps={loginProps} logoutProps={logoutProps} />
    </Overlay>
  );
};
